import { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import LdsIcon from '../LdsIcon/index.jsx';
import TextCaption from './TextCaption.jsx';

export default function FigureCaption({
  children,
  ariaLabel,
  showDescriptionText,
  hideDescriptionText,
  textContent,
  contentMaxHeight,
  contentMaxHeightOverride,
  noCollapse = false,
  transcriptButtonId,
  className,
  expanded = false,
  ...rest
}) {
  const [contentMaxHeights, setContentMaxHeights] = useState({});
  const [transcriptOpen, setTranscriptOpen] = useState(false);
  const transcriptRefs = useRef(null);
  const figureRef = useRef(null);

  function toggleTranscript(isOpen) {
    const { contentRef, captionRef, containerRef } = transcriptRefs.current;
    const maxHeight = contentRef.scrollHeight;
    const style = window.getComputedStyle(containerRef);
    const paddingY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);

    setContentMaxHeights((prevState) => ({
      ...prevState,
      [captionRef.id]: maxHeight + paddingY,
    }));
    setTranscriptOpen(isOpen);
  }

  useEffect(() => {
    if (!noCollapse) toggleTranscript(expanded);
  }, [expanded, noCollapse]);

  function renderCaption() {
    if (noCollapse && typeof textContent === 'string') {
      return (
        <div
          className="figure-caption-no-collapse mt-4"
          dangerouslySetInnerHTML={{ __html: textContent }}
        />
      );
    }

    if (noCollapse && typeof textContent !== 'string') {
      return (
        <div
          className="figure-caption-no-collapse mt-4"
        >
          {textContent}
        </div>
      );
    }
    return (
      <>
        <button
          id={transcriptButtonId}
          onClick={() => toggleTranscript(!transcriptOpen)}
          type="button"
          className="lds-button-base lds-figure-caption-toggle lds-button compact"
        >
          <LdsIcon
            className="lds-figure-caption-toggle-icon"
            name="CaretCircleUpFill"
            decorative
          />
          {transcriptOpen ? hideDescriptionText : showDescriptionText }
        </button>
        <TextCaption
          ref={transcriptRefs}
          textContent={textContent}
          isOpen={transcriptOpen}
          contentMaxHeights={contentMaxHeights}
          contentMaxHeight={contentMaxHeight}
          contentMaxHeightOverride={contentMaxHeightOverride}
          expanded={expanded}
        />
      </>
    );
  }
  return (
    <figure
      ref={figureRef}
      aria-label={ariaLabel || 'Figure with description'}
      className={cn(
        'lds-figure-caption',
        {
          collapsed: !transcriptOpen,
        },
        className
      )}
      {...rest}
    >
      {children}
      {renderCaption()}
    </figure>
  );
}
FigureCaption.propTypes = {
  children: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  showDescriptionText: PropTypes.string,
  hideDescriptionText: PropTypes.string,
  textContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  contentMaxHeight: PropTypes.oneOf(['small', 'medium', 'large']),
  contentMaxHeightOverride: PropTypes.number,
  noCollapse: PropTypes.bool,
  className: PropTypes.string,
};
